import {data}from "./data.js"

import Main from "../../components/Main/Main.js"


const Uranus = () => {
    return (
        <>
        <Main
        planetData={data}
        />
        </>
    )
}

export default Uranus